__turbopack_context__.v({
  "process-video-frame": "WhyWereDifferent-module-scss-module__oqZ-sG__process-video-frame",
});
